export const formatDates = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  export const formatDate = (date: string) => {
    const newDate = new Date(date.replace(" ", "T"));
    const month = newDate.getMonth() + 1;
    const day = newDate.getDate();
    const year = newDate.getFullYear();
    //  const hour = newDate.getHours();
    // const minute = newDate.getMinutes();
    // const second = newDate.getSeconds();
    const newFormatDate = `${day}/${month}/${year} `;
    
    return newFormatDate;
};

export const formatDateTime = (date: string) => {
  const newDate = new Date(date.replace(" ", "T"));
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const year = newDate.getFullYear();
  const hour = newDate.getHours();
  const minute = newDate.getMinutes();

  const newFormatDate = `${day}/${month}/${year} ${hour}:00`;

  return newFormatDate;
};

export const formatDateTimeWithTime = (date: string) => {
  const newDate = new Date(date.replace(" ", "T"));
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const year = newDate.getFullYear();
  const hour = newDate.getHours();
  const minute = newDate.getMinutes();

  const newFormatDate = `${day}/${month}/${year} ${hour}:${minute}`;

  return newFormatDate;
};




export const formatDateWithTime = (date: string) => {
  const newDate = new Date(date.replace(" ", "T"));
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const year = newDate.getFullYear();
  const hour = newDate.getHours().toString().padStart(2, '0');
  const minute = newDate.getMinutes().toString().padStart(2, '0');
  const second = newDate.getSeconds().toString().padStart(2, '0');
  
  const newFormatDate = `${day}/${month}/${year} ${hour}:${minute}`;
  
  return newFormatDate;
};

// export const formatYearMonthDateWithTime = (date: Date): string => {
//   const year = date.getFullYear();
//   const month = (`0${date.getMonth() + 1}`).slice(-2);
//   const day = (`0${date.getDate()}`).slice(-2);
//   const hours = (`0${date.getHours()}`).slice(-2);
//   const minutes = (`0${date.getMinutes()}`).slice(-2);
//   const seconds = (`0${date.getSeconds()}`).slice(-2);
//   return `${year}-${month}-${day} ${hours}:${minutes}`;
// };

export const formatYearMonthDateWithTime = (date: Date) => {
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();
  const hour = date.getHours().toString().padStart(2, '0');
  const minute = date.getMinutes().toString().padStart(2, '0');

  return `${year}-${month}-${day} ${hour}:${minute}`;
};



/**
 * วันที่แบบอ่านง่าย: "วันนี้" / "พรุ่งนี้" / "10 ก.ย. 2569"
 * รับ YYYY-MM-DD จาก backend (ไม่มีโซนเวลาให้พลาด)
 */
const thaiMonths = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];

export const thaiDate = (value?: string | null): string => {
  if (!value) return "-";
  const [y, m, d] = value.split("-").map(Number);
  if (!y || !m || !d) return value;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffDays = Math.round((new Date(y, m - 1, d).getTime() - today.getTime()) / 86400000);

  if (diffDays === 0) return "วันนี้";
  if (diffDays === 1) return "พรุ่งนี้";

  return `${d} ${thaiMonths[m - 1]} ${y + 543}`;
};
